<template>
  <div class="relative">
    <transition name="fade">
      <div v-if="!ready" class="absolute top-0 left-0 col-12 h-12 bg-white z1">
        <div class="md-flex">
          <div class="sidebar flex-none xs-hide sm-hide"></div>
          <div class="flex-auto md-pl2 larger sm-pr2 pointer">
            <responsive-image class="grid-item-img" :image="featured" :max-size="4" @lazybeforeunveil.native="imgReady"/>
          </div>
        </div>
      </div>
    </transition>
    <div :class="{ 'fade-enter': !ready }" class="md-pl2 fade-enter-active">
      <ul class="list-reset m0 larger">
        <grid-item v-for="project in projects" :post="project" :key="project.id"/>
      </ul>
      <p v-if="nothing">No projects</p>
    </div>
  </div>
</template>

<script>
  import store from '@/store'
  import GridItem from '@/components/partials/GridItem'

  export default {
    name: 'index',
    computed: {
      projects () {
        return this.$store.state[this.$route.name] || []
      },
      nothing () {
        return !this.projects.length
      },
      home () {
        return this.$store.state.pages['home']
      },
      featured () {
        if (!this.home || !this.home.acf) return
        const { featured } = this.home.acf
        return featured[Math.floor(Math.random() * featured.length)]
      },
      ready () {
        return this.$store.state.ready
      },
      imgIsReady () {
        return this.$store.state.imgReady
      }
    },
    methods: {
      makeReady () {
        this.$store.commit('READY')
      },
      imgReady () {
        this.$store.commit('IMG_IS_READY', true)
      }
    },
    beforeRouteEnter (to, from, next) {
      let { action } = to.meta
      if (!action) {
        action = 'getCommissions'
      }
      store.dispatch(action).then(next)
    },
    mounted () {
      if (!this.featured) {
        this.makeReady()
      } else {
        setTimeout(() => {
          // this.makeReady()
        }, 2300)
      }
    },
    components: { GridItem }
  }
</script>



// WEBPACK FOOTER //
// src/components/Index.vue